module.exports = __webpack_public_path__ + "static/img/1080_big.d991056.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1080_big.png
// module id = Sp1/
// module chunks = 1